export default defineNuxtRouteMiddleware(async (to) => {
  if (to.hash === "#GoodRiddance" || to.hash === "#GoodRiddanceVIP") {
    if (to.hash === "#GoodRiddanceVIP") {
      useState("grSource", () => "VklQT25TaXRl");
    } else {
      useState("grSource", () => "V2Vic2l0ZUlucHV0");
    }
  }
});
